const data = [
  {
    id: 1451,
    firstName: "Alice",
    lastName: "Smith",
    image: "https://i.pravatar.cc/150?img=1",
    city: "New York"
  },
  {
    id: 1452,
    firstName: "Brooke",
    lastName: "Johnson",
    image: "https://i.pravatar.cc/150?img=9",
    city: "San Francisco"
  },
  {
    id: 1453,
    firstName: "Charlie",
    lastName: "Lee",
    image: "https://i.pravatar.cc/150?img=13",
    city: "Chicago"
  },
  {
    id: 1454,
    firstName: "Jena",
    lastName: "Kim",
    image: "https://i.pravatar.cc/150?img=10",
    city: "Los Angeles"
  },
  {
    id: 1455,
    firstName: "Emily",
    lastName: "Wong",
    image: "https://i.pravatar.cc/150?img=5",
    city: "Toronto"
  },
  {
    id: 1456,
    firstName: "Frank",
    lastName: "Chen",
    image: "https://i.pravatar.cc/150?img=11",
    city: "Houston"
  },
  {
    id: 1457,
    firstName: "Grace",
    lastName: "Park",
    image: "https://i.pravatar.cc/150?img=7",
    city: "Seattle"
  },
  {
    id: 1458,
    firstName: "Henry",
    lastName: "Nguyen",
    image: "https://i.pravatar.cc/150?img=8",
    city: "Miami"
  }
];

export default data;